// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","material_helper_text":"_3iUK2Tp","main_option":"_2N0lk7i","secondary_text":"_1g3LNCT"};